import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Globe, Smartphone, Cloud, Code, Palette, Database, 
  TrendingUp, Shield, Cpu, Gauge, Box, GitBranch 
} from 'lucide-react';
import './ServicesPage.css';

const services = [
  {
    icon: <Globe size={40} />,
    title: 'Web Development',
    description: 'Custom websites, web applications, and e-commerce platforms built with modern frameworks.',
    path: '/services/web-development',
    features: ['React/Angular/Vue', 'Node.js/Python', 'E-commerce', 'CMS Development']
  },
  {
    icon: <Smartphone size={40} />,
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile apps for iOS and Android with stunning UX.',
    path: '/services/mobile-apps',
    features: ['Flutter', 'React Native', 'Swift', 'Kotlin']
  },
  {
    icon: <Cloud size={40} />,
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure, migration, and management services.',
    path: '/services/cloud-solutions',
    features: ['AWS', 'Azure', 'Google Cloud', 'DevOps']
  },
  {
    icon: <Code size={40} />,
    title: 'Custom Software',
    description: 'Tailored software solutions designed for your unique business requirements.',
    path: '/services/custom-software',
    features: ['Enterprise Software', 'API Development', 'Microservices', 'Integration']
  },
  {
    icon: <Palette size={40} />,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces that users love and convert.',
    path: '/services/ui-ux-design',
    features: ['User Research', 'Wireframing', 'Prototyping', 'Usability Testing']
  },
  {
    icon: <Database size={40} />,
    title: 'SaaS Development',
    description: 'End-to-end SaaS platform development from MVP to enterprise scale.',
    path: '/services/saas-development',
    features: ['Multi-tenancy', 'Subscription Management', 'Analytics', 'Scalability']
  },
  {
    icon: <TrendingUp size={40} />,
    title: 'Digital Transformation',
    description: 'Modernize your business processes with cutting-edge technology.',
    path: '/services/digital-transformation',
    features: ['Process Automation', 'Legacy Modernization', 'Digital Strategy']
  },
  {
    icon: <Shield size={40} />,
    title: 'IT Consulting',
    description: 'Expert guidance on technology strategy, architecture, and implementation.',
    path: '/services/it-consulting',
    features: ['Tech Stack Advisory', 'Architecture Review', 'Security Audit']
  },
  {
    icon: <Cpu size={40} />,
    title: 'AI & Machine Learning',
    description: 'Intelligent solutions powered by AI and machine learning.',
    path: '/services/ai-ml',
    features: ['Chatbots', 'Predictive Analytics', 'Computer Vision', 'NLP']
  },
  {
    icon: <Gauge size={40} />,
    title: 'DevOps Services',
    description: 'Streamline development and operations for faster delivery.',
    path: '/services/devops',
    features: ['CI/CD', 'Infrastructure as Code', 'Monitoring', 'Automation']
  },
  {
    icon: <Box size={40} />,
    title: 'MVP Development',
    description: 'Rapid development of minimum viable products for startups.',
    path: '/services/mvp-development',
    features: ['Lean Development', 'Fast Time-to-Market', 'Iterative Approach']
  },
  {
    icon: <GitBranch size={40} />,
    title: 'API Development',
    description: 'Robust, scalable APIs for seamless integration and extensibility.',
    path: '/services/api-development',
    features: ['RESTful APIs', 'GraphQL', 'API Security', 'Documentation']
  }
];

const ServicesPage = () => {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Our <span className="gold-text">Services</span></h1>
          <p>Comprehensive IT solutions tailored to your business needs</p>
        </div>
      </section>

      <section className="services-grid-section section">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="service-features">
                  {service.features.map((feature, i) => (
                    <span key={i} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <Link to={service.path} className="service-link">
                  Learn More →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;